import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Skeleton from '@material-ui/lab/Skeleton';
import MUIDataTable from "mui-datatables";
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import { createMuiTheme } from '@material-ui/core/styles';
import { toTitleCase } from "../../../../../../util/generalUtil"
import {
    getAllCoaches
} from '../../../../../../actions/CoachAction';
import {
    assignCoachToPlayer,
    changeCoachToPlayer,
    removeCoachToPlayer
} from '../../../../../../actions/PlayerAction';
import { tsToDate } from "../../../../../../util/dateUtil"

class CoachAssignModel extends Component {
    state = {
        open: false,
        disableAssignCoachBtn: true,
        selectedCoaches: [],
        coachesData: []
    };

    componentDidUpdate(prevProps) {
        if (prevProps.allCoaches.length !== this.props.allCoaches.length) {
            this.updateCoaches(this.props.allCoaches);
        }
    }
    onCoachModalOpen() {
        const sessionToken = this.props.auth.authUser.sessionToken;
        const allCoaches = this.props.allCoaches;
        this.setState({ open: true })
        if (allCoaches !== null && allCoaches.length > 0) {
            this.updateCoaches(allCoaches);
        } else {
            this.props.getAllCoaches({ sessionToken });
        }
    }

    updateCoaches(allCoaches) {
        var localAllCoaches = [];
        allCoaches.forEach(coachObj => {
            const coach = [coachObj.hasOwnProperty("fullName") ? toTitleCase(coachObj.fullName) : "", coachObj.hasOwnProperty("uid") ? coachObj.uid : "", coachObj.hasOwnProperty("phone") ? coachObj.phone : "", coachObj.hasOwnProperty("gender") ? coachObj.gender : "male", coachObj.hasOwnProperty("city") ? coachObj.city : "", coachObj.hasOwnProperty("country") ? coachObj.country : "", coachObj.hasOwnProperty("startDateTs") ? tsToDate(coachObj.startDateTs) : "", coachObj.hasOwnProperty("status") ? coachObj.status : ""];
            localAllCoaches.push(coach);
        });
        this.setState({ coachesData: localAllCoaches });
    }

    handleRequestClose = () => {
        this.setState({ open: false });
    };

    assignCoach = () => {
        this.setState({ open: false });
        if (this.props.action === "add") {
            const payload = {
                "playerUid": this.props.playerId,
                "coachUid": this.state.selectedCoaches,
                "sessionToken": this.props.auth.authUser.sessionToken
            }
            this.props.assignCoachToPlayer({ payload });
        } else {
            const payload = {
                "playerUid": this.props.playerId,
                "coachUid": this.props.currentCoachUid,
                "newCoachUid": this.state.selectedCoaches[0],
                "sessionToken": this.props.auth.authUser.sessionToken
            }
            this.props.changeCoachToPlayer({ payload });
        }
    };

    removeCoach() {
        const payload = {
            "playerUid": this.props.playerId,
            "coachUid": [this.props.currentCoachUid],
            "sessionToken": this.props.auth.authUser.sessionToken
        }
        this.props.removeCoachToPlayer({ payload });
    }

    getMuiTheme = () =>
        createMuiTheme({
            overrides: {
                MUIDataTable: {
                    root: {
                        backgroundColor: '#AAF',
                    },
                    paper: {
                        boxShadow: 'none',
                    },
                },
                MuiToolbar: {
                    root: {
                        backgroundColor: '#f00',
                    },
                },
                MuiTableCell: {
                    head: {
                        backgroundColor: 'purple',
                    },
                },
                MUIDataTableSelectCell: {
                    headerCell: {
                        backgroundColor: 'blue',
                    },
                },
                MuiTableFooter: {
                    root: {
                        '& .MuiToolbar-root': {
                            backgroundColor: 'white',
                        },
                    },
                },
            },
        });

    toggleDenseTable = event => {
        this.setState({
            denseTable: event.target.checked,
        });
    };

    toggleResponsive = event => {
        this.setState({
            vertical: !!event.target.checked,
        });
    };

    customCoachToolbarSelect(selectedRows) {
        return (
            <div>
            </div>
        );
    }

    handleRowSelected = (currentRowsSelected, allRowsSelected) => {
        if (allRowsSelected && allRowsSelected.length > 0) {
            var localSelectedCoaches = []
            // allRowsSelected.map((data, index) => 
            for (var index = 0; index < allRowsSelected.length; index++) {
                localSelectedCoaches.push(this.state.coachesData[allRowsSelected[index].dataIndex][1])
            }
            this.setState({
                disableAssignCoachBtn: false,
                selectedCoaches: localSelectedCoaches
            })
        } else {
            this.setState({
                disableAssignCoachBtn: true,
                selectedCoaches: []
            })
        }
    }


    render() {
        var selectableRows = "multiple"
        if (this.props.action === "change") {
            selectableRows = "single"
        } else {
            selectableRows = "multiple"
        }

        let closeButton = {
            position: 'absolute',
            zIndex: 1
        };

        const columns = [
            {
                name: "Name",
                options: {
                    filter: false,
                    setCellHeaderProps: value => ({ style: { textDecoration: 'underline' } }),
                }
            },
            {
                name: "Email",
                options: {
                    filter: true
                }
            },
            {
                name: "Phone",
                options: {
                    filter: false,
                    display: false
                }
            },
            {
                name: "Gender",
                options: {
                    filter: true,
                    display: false
                }
            },
            {
                name: "City",
                options: {
                    filter: false,
                    display: false
                }
            },
            {
                name: "Country",
                options: {
                    filter: false,
                    display: false
                }
            },
            {
                name: "Activation Date",
                options: {
                    filter: false
                }
            },
            {
                name: "Status",
                options: {
                    filter: true
                }
            }
        ];

        const options = {
            filterType: "dropdown",
            responsive: "scroll",
            selectableRows: selectableRows,
            selectableRowsOnClick: true,
            onRowsSelect: this.handleRowSelected,
            customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
                this.customCoachToolbarSelect(selectedRows)
            ),
            isRowSelectable: (dataIndex) => {
                //prevents selection of row with title "Attorney"
                var isSelect = true
                if (this.props.eacl != null) {
                    this.props.eacl.forEach(coach => {
                        if ((coach.euid === this.state.coachesData[dataIndex][1]) && (coach.status === "active")) {
                            isSelect = false
                        }
                    })
                }
                return isSelect;
            }
        };

        return (
            <span>
                {this.props.action === "add" ?
                    <Button className="jr-btn" color="primary" size="large" fontSize="large" onClick={() => this.onCoachModalOpen()} >
                        <i className="zmdi zmdi-plus-circle-o" />
                        <span>Assign Coaches</span>
                    </Button> : this.props.action === "change" ?
                        <Button variant="contained" className="jr-btn bg-indigo text-white jr-btn-sm" onClick={() => this.onCoachModalOpen()} >
                            <i className="zmdi zmdi-refresh" />
                            <span className="mr-1">Change </span>
                        </Button> :
                        <Button variant="contained" className="jr-btn bg-deep-orange text-white jr-btn-sm" onClick={() => this.removeCoach()} >
                            <i className="zmdi zmdi-close-circle-o" />
                            <span>Remove</span>
                        </Button>
                }
                <Dialog
                    fullWidth
                    maxWidth='xl'
                    open={this.state.open} onClose={this.handleRequestClose}>
                    <IconButton aria-label="Close" style={closeButton} onClick={this.handleRequestClose}>
                        <CloseIcon />
                    </IconButton>
                    <div className="row m-3">
                        <div className="col-6">
                            <DialogTitle>
                                {"Select a coach from list"}
                            </DialogTitle>
                        </div>
                        <div className="col-6">
                            <DialogActions>
                                <Button variant="contained" disabled={this.state.disableAssignCoachBtn} className="jr-btn bg-teal text-white" onClick={this.assignCoach} color="primary">
                                    Save
                                </Button>
                            </DialogActions>
                        </div>
                    </div>
                    <DialogContent>
                        {this.props.allCoachLoader ? (
                            <div>
                                <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 130 }} />
                                <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                                <Skeleton animation="wave" variant="rect" className="mb-1" style={{ height: 65 }} />
                            </div>
                        ) : (
                                <MUIDataTable
                                    title={"Coaches"}
                                    data={this.state.coachesData}
                                    columns={columns}
                                    options={options}
                                />
                            )}
                    </DialogContent>

                </Dialog>
            </span>
        );
    }
}

const mapStateToProps = ({ coach, auth, player }) => {
    const { allCoaches, allCoachLoader } = coach;
    return { allCoaches, allCoachLoader, auth }
}
export default withRouter(connect(mapStateToProps, {
    getAllCoaches,
    assignCoachToPlayer,
    changeCoachToPlayer,
    removeCoachToPlayer
})(CoachAssignModel));